var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgListedocument = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.426,
    height: 15,
    viewBox: "0 0 11.426 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "liste-document",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_106",
    "data-name": "Trac\\xE9 106",
    d: "M72.3,3.644,68.781.129A.44.44,0,0,0,68.471,0H62.318A1.32,1.32,0,0,0,61,1.318V13.682A1.32,1.32,0,0,0,62.318,15h8.789a1.32,1.32,0,0,0,1.318-1.318V3.955A.444.444,0,0,0,72.3,3.644ZM68.91,1.5l2.015,2.015H69.35a.44.44,0,0,1-.439-.439Zm2.2,12.621H62.318a.44.44,0,0,1-.439-.439V1.318a.44.44,0,0,1,.439-.439h5.713v2.2A1.32,1.32,0,0,0,69.35,4.395h2.2v9.287A.44.44,0,0,1,71.107,14.121Z",
    transform: "translate(0)",
    fill: "#5572a7"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListedocument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/listedocument.08282f87.svg";
export { ForwardRef as ReactComponent };